import CustomBlockButton from "../../../../../../../components/button/CustomBlockButton";
import { CustomDialog } from "../../../../../../../components/dialog/v1/CustomDialog";
import styled from 'styled-components';
import { CustomLabelInput } from "../../../../../../../components/input/CustomLabelInput";
import { useState } from "react";
import { useApiInfoContextValueHook } from "../../../../../../../contexts/ApiInfoContext";
import { useFetcher } from "../../../../fetcher/useFetcher";
import { customToast } from "../../../../../../../components/toast/custom-react-toastify/v1";
import { SellertoolSignatureUtils } from "../../../../../../../utils/sellertool-signature-utils";
import { CustomBackdropController } from "../../../../../../../components/backdrop/default/v1";
import { ReturnExchangeArchivesApi } from "../../../../../../../apis/ReturnExchangeArchivesApi";

const StyledHeader = styled.div`
    padding: 10px;
`;

const StyledBody = styled.div`
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .description{
        margin-top: 10px;
        margin-bottom: 10px;
        font-size: 14px;
    }

    input{
        border-color: #e0e0e0;
        border-radius: 3px;
    }

    .textareaBox{
        border-color: #e0e0e0;
        border-radius: 3px;
    }
`;

const StyledFooter = styled.div`
    padding: 10px;
    button{
        border-radius: 3px;
        border: none;
        color: #fff;
        background-color: var(--redColor1);
        font-weight: 600;
    }
`;

export function DeleteModal({
    open,
    onClose,
    selectedArchive
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();
    const fetcher = useFetcher();

    const [inputValue, setInputValue] = useState('');

    const handleChangeInputValue = (e) => {
        const value = e.target.value;
        setInputValue(value);
    }

    const handleSubmit = async () => {
        if (!inputValue) {
            customToast.error('입력창을 입력해 주세요.');
            return;
        }

        if(inputValue !== '영구 삭제'){
            customToast.error('입력창을 확인해 주세요.');
            return;
        }

        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        const body = {
            formData: selectedArchive
        }

        CustomBackdropController().showBackdrop();
        const response = await ReturnExchangeArchivesApi().deleteOne({ headers: headers, body: body });
        
        if (response?.content) {
            await fetcher.fetchReturnExchangeArchives();
            customToast.success('삭제되었습니다.');
            onClose();
        }
        CustomBackdropController().hideBackdrop();
    }

    return (
        <>
            <CustomDialog
                open={open}
                onClose={onClose}
            >
                <StyledHeader>
                    <CustomDialog.Header>
                        <CustomDialog.Header.Fake />
                        <CustomDialog.Header.Title>
                            삭제
                        </CustomDialog.Header.Title>
                        <CustomDialog.Header.Close onClick={onClose} />
                    </CustomDialog.Header>
                </StyledHeader>
                <StyledBody>
                    <div className='description'>
                        <div>보관함을 삭제 하시려면 <b>"영구 삭제"</b>를 입력해 주세요.</div>
                    </div>
                    <CustomLabelInput>
                        <CustomLabelInput.Input
                            type='text'
                            value={inputValue || ''}
                            onChange={handleChangeInputValue}
                        />
                        <CustomLabelInput.Label>입력</CustomLabelInput.Label>
                    </CustomLabelInput>
                </StyledBody>
                <StyledFooter>
                    <CustomBlockButton
                        type='button'
                        onClick={handleSubmit}
                    >
                        삭제
                    </CustomBlockButton>
                </StyledFooter>
            </CustomDialog>
        </>
    );
}